import clsx from 'clsx';
import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

export interface SidebarItem {
  label: string;
  path?: string;
  icon?: React.ReactNode;
  active?: boolean;
}

export interface SidebarProps {
  items: SidebarItem[];
  className?: string;
}

export const Sidebar: React.FC<SidebarProps> = ({ items, className }) => {
  return (
    <aside className={clsx('bg-white border-r border-neutral-200', className)}>
      <nav className="p-4 space-y-1">
        {items.map((item, index) => {
          if (item.path) {
            return (
              <NavLink
                key={index}
                to={item.path}
                className={({ isActive }) =>
                  clsx(
                    'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-purple-100 text-purple-600'
                      : 'text-neutral-600 hover:bg-neutral-100'
                  )
                }
              >
                {item.icon && <span className="text-lg">{item.icon}</span>}
                <span className="flex-1">{item.label}</span>
              </NavLink>
            );
          }

          return (
            <button
              key={index}
              type="button"
              className={clsx(
                'w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                item.active
                  ? 'bg-purple-100 text-purple-600'
                  : 'text-neutral-600 hover:bg-neutral-100'
              )}
            >
              {item.icon && <span className="text-lg">{item.icon}</span>}
              <span className="flex-1 text-left">{item.label}</span>
              <FiChevronDown className="w-4 h-4" />
            </button>
          );
        })}
      </nav>
    </aside>
  );
};
